import { render, staticRenderFns } from "./warehouse_area_code.vue?vue&type=template&id=200ac10f&scoped=true&"
import script from "./warehouse_area_code.vue?vue&type=script&lang=js&"
export * from "./warehouse_area_code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200ac10f",
  null
  
)

export default component.exports